export class PipelineHistorySummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "recordedAt",
            "baseName": "recordedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "PipelineHistoryKind",
            "format": ""
        },
        {
            "name": "actorId",
            "baseName": "actorId",
            "type": "string",
            "format": ""
        },
        {
            "name": "source",
            "baseName": "source",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PipelineHistorySummary.attributeTypeMap;
    }
    constructor() {
    }
}
